var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHardwareDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.85 25.3a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0m-13 0a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0",
    stroke: "#fff",
    strokeWidth: 1.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.35 25.3h-6.5m13 0h.992c.286 0 .429 0 .549-.016a1.95 1.95 0 0 0 1.693-1.692c.016-.121.016-.264.016-.55V19.45A8.45 8.45 0 0 0 22.65 11M5.1 7.75h13c1.838 0 2.757 0 3.328.572.572.57.572 1.489.572 3.328V22.7M5.1 19.125v2.925c0 1.215 0 1.823.261 2.275.171.296.418.543.714.714.452.261 1.06.261 2.275.261M5.1 11.65h7.8m-7.8 3.9h5.2",
    stroke: "#fff",
    strokeWidth: 1.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardwareDelivery);
export default __webpack_public_path__ + "static/media/hardwareDelivery.12cc5dfbaf3ce71d343909715f880e7f.svg";
export { ForwardRef as ReactComponent };